import { useTransferStore, TransferCoordinator } from '@share/core';
import type { ResolvedReceiveLink, ReceiveSessionResult, ShareSessionResult } from '@share/core';
import type { TorrentDestination } from '@share/networking';

export function useTransferViewModel() {
  const sessionsMap = useTransferStore((state) => state.sessions);
  const sessionsList = Object.values(sessionsMap).sort((a, b) => b.createdAt - a.createdAt);

  return {
    transfers: sessionsList,
    startShare: (files: any[], opts?: { expiry?: string }): Promise<ShareSessionResult> =>
      TransferCoordinator.startSendSession(files, opts),
    startDownload: (resolved: ResolvedReceiveLink, destination: TorrentDestination): Promise<ReceiveSessionResult> =>
      TransferCoordinator.startReceiveSession(resolved, destination),
    pauseTransfer: (id: string) => TransferCoordinator.pauseSession(id),
    resumeTransfer: (id: string) => TransferCoordinator.resumeSession(id),
    cancelTransfer: (id: string, deleteData?: boolean) => TransferCoordinator.cancelSession(id, deleteData ?? false),
  };
}

